import { useState } from 'react';
import { Routes, Route } from 'react-router-dom';
import { ArrowUp, MessageCircle } from 'lucide-react';

import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import CallbackModal from './components/CallbackModal';

import Home from './pages/Home';
import ParalegalServices from './pages/ParalegalServices';
import AreaOfPractice from './pages/AreaOfPractice';
import ServiceDetail from './pages/ServiceDetail';
import ContactUs from './pages/ContactUs';
import Blog from './pages/Blog';

import './App.css';

export default function App() {
  const [callbackOpen, setCallbackOpen] = useState(false);

  return (
    <>
      <ScrollToTop />
      <Header />

      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/paralegal-services" element={<ParalegalServices />} />
          <Route path="/area-practice" element={<AreaOfPractice />} />
          <Route path="/contact-us" element={<ContactUs />} />
          <Route path="/blog" element={<Blog />} />

          {/* Dynamic service/practice area detail pages */}
          <Route path="/:slug" element={<ServiceDetail />} />
        </Routes>
      </main>

      <Footer />

      {/* Floating "Start a Free Trial" / Callback Button */}
      <button
        className="floating-cta"
        onClick={() => setCallbackOpen(true)}
        aria-label="Request Callback"
      >
        <MessageCircle size={20} />
        <span>Start a Free Trial</span>
      </button>

      {/* Scroll to Top */}
      <ScrollToTopButton />

      {/* Callback Modal */}
      <CallbackModal isOpen={callbackOpen} onClose={() => setCallbackOpen(false)} />
    </>
  );
}

function ScrollToTopButton() {
  const [visible, setVisible] = useState(false);

  if (typeof window !== 'undefined') {
    window.addEventListener('scroll', () => {
      setVisible(window.scrollY > 400);
    });
  }

  if (!visible) return null;

  return (
    <button
      className="scroll-top"
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      aria-label="Scroll to top"
    >
      <ArrowUp size={20} />
    </button>
  );
}
